// extracted by mini-css-extract-plugin
export default {"card":"OrderStatsItem_card__ieCBW","name":"OrderStatsItem_name__dcpUc"};